import * as Const from '../constants';
import State from '../interfaces/state/SubscriptionLimit';

const initState: State = {
  list: [],
  isLoading: false,
  isError: false,
};

export default function subscriptionLimit(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.SUBS_LIMIT_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.SUBS_LIMIT_SUCCESS:
      return {
        ...state,
        list: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.SUBS_LIMIT_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.SUBS_LIMIT_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    default:
      return state;
  }
}
